export const PORTAL_ACTIONS = {
  UPDATE_DATA: 'updateData',
  UPDATE_SCHEMA: 'updateSchema',
  UPDATE_BLOCK: 'updateBlock',
  REVERT_SOURCES: 'revertSources',
  SAVE_SOURCES: 'saveSources',
  SEND_SCHEMA: 'sendSchema',
  SET_SOURCES: 'setSources',
  RESET_SCHEMA: 'resetSchema',
  SAVE_CURRENT_VIEW: 'saveCurrentView',
  SAVE_CURRENT_VIEW_SET: 'saveCurrentViewSet',
  ACTIVATE_VIEW: 'activateView',
  REVERT_CURRENT_VIEW: 'revertCurrentView',
  ADD_VIEW: 'addView',
  ADD_VIEW_SET: 'addViewSet',
  UPDATE_VIEW_TITLE: 'updateViewTitle',
  DELETE_VIEW: 'deleteView',
  DELETE_VIEW_SET: 'deleteViewSet',
  REPLACE_VIEW: 'replaceView'
} as const

export type PortalActionType = (typeof PORTAL_ACTIONS)[keyof typeof PORTAL_ACTIONS]
